<template>
  <generic-modal :title="$t('work order detail')" ref="generic_modal">
    <div class="box mb-4">
      <div class="columns is-mobile is-vcentered mb-2">
        <div class="column">
          <div class="title is-4 mb-1">{{ meta.name }}</div>
          <div class="subtitle is-6 mb-0">{{ meta.source }}</div>
        </div>
        <div class="column is-narrow has-text-right">
          <div class="mb-1">
            <span class="icon has-text-info"
              ><i class="fa fa-clock-o"></i
            ></span>
            <span class="has-text-weight-semibold">{{ $t("status") }}</span>
            <span class="tag is-info ml-2">{{
              translate_status(meta.status_code)
            }}</span>
          </div>
          <div class="mb-1">
            <span class="icon"><i class="fa fa-calendar"></i></span>
            <span class="has-text-weight-semibold">{{ $t("created") }}</span>
            <span>{{ format_date(meta.create_date) }}</span>
          </div>
          <div v-if="meta.settings">
            <span class="icon has-text-warning"
              ><i class="fa fa-calendar"></i
            ></span>
            <span class="has-text-weight-semibold">{{
              $t("delivery date")
            }}</span>
            <span>{{ format_date(meta.settings.delivery_date) }}</span>
          </div>
        </div>
      </div>

      <hr class="my-2" />

      <div class="columns is-multiline">
        <div class="column is-6">
          <div class="title is-6 mb-2">{{ $t("summary") }}</div>
          <ul>
            <li v-for="(item, idx) in summary" :key="idx">
              <span class="tag is-primary mr-2">{{ item.quantity }}</span>
              <span>{{ item.product }}</span>
            </li>
          </ul>
        </div>
        <div class="column is-6" v-if="customs && customs.length">
          <div class="title is-6 mb-2">{{ $t("customized orders") }}</div>
          <ul>
            <li v-for="(custom, cidx) in customs" :key="cidx">
              <span class="tag is-warning mr-2">{{
                Number(custom.quantity)
              }}</span>
              <span
                >{{ custom.product.name }} {{ custom.size.toUpperCase() }}</span
              >
              <span v-if="custom.customization" class="has-text-grey">
                ({{ custom.customization }})
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div class="title is-6 mb-2 mt-4">{{ $t("order details") }}</div>
      <div v-if="orders_table && orders_table.length">
        <table class="table is-striped is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th>{{ $t("product") }}</th>
              <th>{{ $t("quantity") }}</th>
              <th>{{ $t("size") }}</th>
              <th>{{ $t("customization") }}</th>
              <th>{{ $t("customer") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in orders_table" :key="idx">
              <td>{{ item.product.name }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.size.toUpperCase() }}</td>
              <td>{{ item.customization }}</td>
              <td>
                {{ item.tailoring_order.name }} -
                {{ item.tailoring_order.grade }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="title is-6 mb-2 mt-5">{{ $t("material list") }}</div>
      <div v-if="material_list && material_list.length">
        <table class="table is-striped is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th>{{ $t("material") }}</th>
              <th>{{ $t("quantity") }}</th>
              <th>{{ $t("unit") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in material_list" :key="idx">
              <td>{{ item.product }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.unit }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <div v-if="order_list && order_list.length">
        <div
          v-for="(ord, cidx) in order_list"
          :key="cidx"
          class="box mb-3 py-3 px-4"
        >
          <div class="is-flex is-align-items-center mb-2">
            <span class="title is-6 mr-2">{{ ord.name }}</span>
            <div class="tags ml-2">
              <span class="tag is-link">
                <span class="icon is-small"><i class="fa fa-phone"></i></span>
                {{ ord.phone }}
              </span>
              <span class="tag is-link">
                <span class="icon is-small"><i class="fa fa-at"></i></span>
                {{ ord.email }}
              </span>
              <span class="tag is-link">
                <span class="icon is-small"
                  ><i class="fa fa-graduation-cap"></i
                ></span>
                {{ ord.grade }}
              </span>
            </div>
          </div>
          <ul>
            <li v-for="(item, iidx) in ord.tailoring_order_items" :key="iidx">
              <span class="tag is-info mr-2">{{ Number(item.quantity) }}</span>
              <span
                >{{ item.product.name }} - {{ item.size.toUpperCase() }}</span
              >
              <span v-if="item.customization" class="has-text-grey">
                ({{ item.customization }})
              </span>
            </li>
          </ul>
        </div>
      </div> -->
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  post,
  get,
  generate_error_message_text,
  format_date,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import { groupBy } from "lodash";
import status_catalog from "../../status.json";

export default {
  name: "WorkOrderModal",
  components: { GenericModal, GenericCalendar },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    summary() {
      let v = this;
      if (v.meta && v.meta.work_order_items) {
        let items = v.meta.work_order_items.reduce((acc, item) => {
          return acc.concat(item.tailoring_order.tailoring_order_items);
        }, []);
        let grouped = groupBy(items, (i) => {
          return `${i.product.name} ${v.$t("size")} ${i.size.toUpperCase()}`;
        });
        let arr = Object.keys(grouped).map((key) => {
          return {
            product: key,
            quantity: grouped[key].reduce(
              (acc, i) => acc + Number(i.quantity),
              0
            ),
          };
        });
        return arr.sort((a, b) => {
          // return a.city.localeCompare(b.product) || b.price - a.price;
          if (a.product < b.product) return -1;
          else if (a.product > b.product) return 1;
          else return 0;
        });
      } else return [];
    },
    customs() {
      let v = this;
      if (v.meta && v.meta.work_order_items) {
        let items = v.meta.work_order_items.reduce((acc, item) => {
          return acc.concat(item.tailoring_order.tailoring_order_items);
        }, []);
        let filtered = items.filter((i) => i.customization);
        return filtered.sort((a, b) => {
          if (a.product.name < b.product.name) return -1;
          if (a.product.name > b.product.name) return 1;
          return 0;
        });
      } else return [];
    },
    order_list() {
      let v = this;
      if (v.meta && v.meta.work_order_items) {
        let orders = v.meta.work_order_items.reduce((acc, item) => {
          acc.push(item.tailoring_order);
          return acc;
        }, []);
        return orders;
      } else return [];
    },
    orders_table() {
      let v = this;
      if (v.meta && v.meta.work_order_items) {
        let orders = v.meta.work_order_items.reduce((acc, item) => {
          let items = item.tailoring_order.tailoring_order_items.map((i) => {
            i.tailoring_order = {
              uuid: item.tailoring_order.uuid,
              name: item.tailoring_order.name,
              phone: item.tailoring_order.phone,
              email: item.tailoring_order.email,
              grade: item.tailoring_order.grade,
            };
            return i;
          });

          let r = acc.concat(items);

          return r;
        }, []);
        return orders;
      } else return [];
    },
    material_list() {
      let v = this;
      if (v.orders_table) {
        let materials = v.orders_table.reduce((acc, item) => {
          if (item.product && item.product.combo_products) {
            let combo = item.product.combo_products.map((c) => {
              return {
                product: c.product_name,
                unit: c.unit_name,
                quantity: Number(c.quantity) * item.quantity,
              };
            });
            return acc.concat(combo);
          } else {
            return [];
          }
        }, []);

        let grouped = groupBy(materials, (i) => {
          return `${i.product} ${i.unit}`;
        });
        let arr = Object.keys(grouped).map((key) => {
          return {
            grouper: key,
            quantity: grouped[key].reduce(
              (acc, i) => acc + Number(i.quantity),
              0
            ),
            unit: grouped[key][0].unit,
            product: grouped[key][0].product,
          };
        });
        return arr.sort((a, b) => {
          // return a.city.localeCompare(b.product) || b.price - a.price;
          if (a.product < b.product) return -1;
          else if (a.product > b.product) return 1;
          else return 0;
        });
      } else return [];
    },
  },
  methods: {
    format_currency,
    format_date,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();
      get("/work_order", { uuid })
        .then((work_order) => {
          v.meta = work_order;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.error = "";
    },
    translate_status(status) {
      let v = this;
      let trgt = status_catalog[status];
      if (trgt) return v.$t(trgt.text);
      return status;
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>
<style>
.box {
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(44, 62, 80, 0.08);
}
ul {
  margin-bottom: 0.5em;
}
li {
  margin-bottom: 0.3em;
}
.tags .tag {
  margin-right: 0.3em;
}
</style>
